import * as React from "react";
import { Sheet as SheetRoot, SheetContent, SheetHeader, SheetTitle, SheetFooter } from "./ui/sheet";

export interface SheetProps {
  open?: boolean;
  /** Which edge the panel anchors to. @default "bottom" */
  side?: "bottom" | "top";
  title: React.ReactNode;
  eyebrow?: string;
  onClose?: () => void;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  /** "fixed" covers the viewport; "inline" covers the nearest positioned ancestor (e.g. a phone frame). @default "fixed" */
  container?: "fixed" | "inline";
  style?: React.CSSProperties;
}


export function Sheet({open = false, side = "bottom", title, eyebrow, onClose, footer, children,
  container = "fixed", style}: SheetProps) {
  const opener = React.useRef<HTMLElement | null>(null);
  return <SheetRoot open={open} onOpenChange={next => { if (!next) onClose?.(); }}>
    <SheetContent side={side} container={container} style={style} showCloseButton={Boolean(onClose)}
      aria-describedby={undefined} onOpenAutoFocus={() => { opener.current = document.activeElement as HTMLElement; }} onCloseAutoFocus={event => {event.preventDefault(); opener.current?.focus();}}
      className="max-h-[90%] overflow-y-auto rounded-xl p-5">
      <SheetHeader className="p-0 pr-8">
        {eyebrow && <div className="text-[length:var(--text-micro)] font-extrabold uppercase tracking-[var(--tracking-eyebrow)] text-muted-foreground">{eyebrow}</div>}
        <SheetTitle className="m-0 font-[family-name:var(--font-display)] text-[length:var(--text-title-lg)]">{title}</SheetTitle>
      </SheetHeader>
      {children}
      {footer && <SheetFooter className="p-0">{footer}</SheetFooter>}
    </SheetContent>
  </SheetRoot>;
}
